const urlBase64ToUint8Array = (base64) => {
  const padding = '='.repeat((4 - (base64.length % 4)) % 4)
  const raw = atob((base64 + padding).replace(/-/g, '+').replace(/_/g, '/'))
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)))
}

export const pushSupported = () =>
  typeof window !== 'undefined' &&
  'serviceWorker' in navigator &&
  'PushManager' in window &&
  'Notification' in window

// Create (or reuse) this browser's subscription and tell the server it belongs to me
export const subscribePush = async (api) => {
  await navigator.serviceWorker.register('/sw.js')
  const reg = await navigator.serviceWorker.ready

  const { data } = await api.get('/api/push/vapid-key')
  const key = urlBase64ToUint8Array(data.key)

  let sub = await reg.pushManager.getSubscription()

  // The server key was changed: the old subscription can not be used any more
  if (sub) {
    const current = sub.options?.applicationServerKey ? new Uint8Array(sub.options.applicationServerKey) : null
    const same = current && current.length === key.length && current.every((b, i) => b === key[i])
    if (!same) {
      await sub.unsubscribe()
      sub = null
    }
  }

  if (!sub) {
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: key })
  }

  await api.post('/api/push/subscribe', { subscription: sub.toJSON() })
  return sub
}

// Logout: the server stops sending to this browser for me (the browser keeps its subscription)
export const forgetPushOnServer = async (api) => {
  if (!pushSupported()) return
  try {
    const reg = await navigator.serviceWorker.getRegistration()
    const sub = await reg?.pushManager.getSubscription()
    if (sub) await api.post('/api/push/unsubscribe', { endpoint: sub.endpoint })
  } catch {
    /* logging out must never fail because of this */
  }
}

// "Turn off" in the menu: remove it on the server and in the browser
export const disablePush = async (api) => {
  const reg = await navigator.serviceWorker.getRegistration()
  const sub = await reg?.pushManager.getSubscription()
  if (!sub) return

  await api.post('/api/push/unsubscribe', { endpoint: sub.endpoint }).catch(() => {})
  await sub.unsubscribe()
}